<template>
    <v-flex xs12 md10 offset-md1>
        <v-toolbar color="blue" dark>
            <v-toolbar-title>Group Users</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-card>
            <span v-for="(user, index) in users" :key="index">
              <v-chip>
                <v-avatar>
                  <v-icon>account_circle</v-icon>
                </v-avatar>
                {{ $store.state.users[user].email  }}
              </v-chip>
            </span>
            <v-card-title>
                <v-text-field
                        v-model="newUser"
                        label="Add new User to Group"
                        single-line
                        hide-details
                ></v-text-field>
                <v-btn color="default" @click="addNewUser">Add</v-btn>
            </v-card-title>
        </v-card>
        <v-dialog v-model="addUserDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Add New User?</v-card-title>
                <v-card-text>Please confirm that you want to add {{newUser}} this group.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click.native="proceed">Yes, add user</v-btn>
                    <v-btn color="green darken-1" flat @click.native="addUserDialog = false">No, cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        name: "GroupUsers",
        props: ['group', 'users'],
        data() {
            return {
                newUser: '',
                addUserDialog: false
            }
        },
        methods: {
            ...mapActions(['addUserToGroup']),
            addNewUser: function () {
                if (this.newUser !== '') {
                    this.addUserDialog = true
                }
            },
            proceed: function () {
                this.addUserDialog = false
                this.addUserToGroup([this.group, this.newUser])
                this.newUser = ''
            }
        }
    }
</script>

<style scoped>

</style>
